
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar} from 'react-bootstrap'

import FontAwesome from 'react-fontawesome'
import SupplierPage from './SupplierPage'


class SupplierPageModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

    //this.openPopup() 
  }

  openPopup(){
    console.log("ref",this.refs.swtCustPop)
    //this.refs.swtCustPage.loadPage()
  }

  onSelectSupplierItem(item){
    if(this.props.onSelect !==undefined){
      this.props.onSelect(item)
    }else if(window.onSelectSupplierItem!==undefined){
      window.onSelectSupplierItem(item)
    }

    if(this.props.onHide!==undefined)
      this.props.onHide()
  }

  render(){
    let {show,showNew} = this.props
    
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="fullwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'ค้นหาร้านค้า'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SupplierPage ref={'swtCustPage'} 
          showNew={showNew}           
          onSelectItem={this.onSelectSupplierItem.bind(this)}/>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  }
}


export default SupplierPageModal;





// WEBPACK FOOTER //
// ./src/view/po/SupplierPageModal.js